<main class="w-100 d-flex justify-content-center">
  <div class="sitemap">
    <h1>{{ 'content.tu-direct-site-map' | translate }}</h1>
    <h2>{{ 'content.account' | translate }}</h2>
    <ul>
      <li>
        @if (isLoggedIn) {
          <a class="tu-link" routerLink="/edit-profile">{{ 'content.edit-profile' | translate }}</a>
        } @else {
          <a class="tu-link" routerLink="/login">{{ 'content.login' | translate }}</a>
        }
      </li>
      <li>
        <a class="tu-link" routerLink="/forgot-password">{{ 'content.forgot-password' | translate }}</a>
      </li>
    </ul>
    @if (isAdmin) {
      <div>
        <h2>{{ 'content.administration' | translate }}</h2>
        <ul>
          <li>
            <a class="tu-link" routerLink="/admin" [attr.aria-label]="'content.view-the-admin-page' | translate">
              {{ 'content.admin-title' | translate }}
            </a>
            <ul>
              @if (isTuAdmin) {
                <li>
                  <a class="tu-link" routerLink="/admin/users" [attr.aria-label]="'content.view-the-admin-users-page' | translate">
                    {{ 'content.users' | translate }}
                  </a>
                  <ul>
                    <li>
                      <a class="tu-link" routerLink="/admin/users/new" [attr.aria-label]="'content.create-a-new-user' | translate">
                        {{ 'content.create-new-user' | translate }}
                      </a>
                    </li>
                  </ul>
                </li>
              }
              @if (isTuAdmin) {
                <li>
                  <a class="tu-link" routerLink="/admin/companies" [attr.aria-label]="'content.view-the-admin-companies-page' | translate">
                    {{ 'content.companies' | translate }}
                  </a>
                  <ul>
                    <li>
                      <a class="tu-link" routerLink="/admin/companies/new">{{ 'content.create-new-company' | translate }}</a>
                    </li>
                  </ul>
                </li>
              }
            </ul>
          </li>
        </ul>
      </div>
    }
    @if (isConsumer) {
      <div>
        <h2>{{ 'content.consumer-services' | translate }}</h2>
        <ul>
          <li><a class="tu-link" routerLink="/consumer-services" [attr.aria-label]="'content.go-to-the-consumer-page' | translate">{{ 'content.consumer-services' | translate }}</a></li>
        </ul>
      </div>
    }
    @if (isBusiness) {
      <div>
        <h2>{{ 'content.business-services' | translate }}</h2>
        <ul>
          <li>
            <a class="tu-link" routerLink="/business-services" [attr.aria-label]="'content.go-to-the-business-page' | translate">
              {{ 'content.business-services' | translate }}
            </a>
          </li>
        </ul>
      </div>
    }
  </div>
</main>
